import { BusinessDetails } from '../../slices/businessDetails';
import { CoverDetails } from '../../slices/coverDetails';
import { Quote } from '../../slices/quote';
import { Cover } from '../../types/cover';
import { RiskClassCode } from '../../types/risk';
import { Nullable } from '../../types/utils';
import { RiskMetaType } from './getRiskMeta';

export const getPortableItemsRisk = ({
  riskMeta,
  requestCovers,
  coverDetails,
  businessDetails: { occupation },
  quote,
}: {
  riskMeta: RiskMetaType;
  requestCovers: Cover[];
  coverDetails: Nullable<CoverDetails>;
  quote: Nullable<Quote>;
  businessDetails: Partial<BusinessDetails>;
}) => ({
  ...riskMeta,
  riskClassCode: RiskClassCode.PortableItems,
  riskDetail: {
    riskBPKGeneralPropertyMachineryBreakdown: {
      occupationCode: occupation?.anzsicCode ?? '',
      occupationDescription: occupation?.occupation ?? '',
      business: occupation?.occupation ?? '',
      generalProperty: requestCovers.includes(Cover.PortableItems)
        ? {
            generalPropertySumInsured: coverDetails.totalCoverValue ?? 0,
            generalPropertyExcess: Math.min(
              quote.levelOfExcess!,
              coverDetails.totalCoverValue ?? 0
            ),
            itemList: [
              ...(coverDetails.blanketCovers ?? []),
              ...(coverDetails.specifiedItems ?? []),
            ].map((itemCover) => ({
              itemGroup: itemCover.code,
              itemDescription: itemCover.description ?? itemCover.category,
              serialNumber: itemCover.serialNumber,
              itemSI: itemCover.value,
            })),
          }
        : {
            generalPropertySumInsured: 0,
            generalPropertyExcess: 0,
            itemList: [],
          },
      ...(requestCovers.includes(Cover.Breakdown) && {
        machineryBreakdown: {
          machineryBreakDownExcess: quote.levelOfExcess!,
          machineryBlanketSI: coverDetails.breakdown?.sumInsured,
          machineryBlanketNumberOfItems: coverDetails.breakdown?.numberOfItems,
          deteriorationOfStockSI: coverDetails.breakdown?.deteriorationOfStock,
        },
      }),
    },
  },
});
